import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { Modal, DeleteModal } from "../Modal";
import { CSVLink } from "react-csv";
import exportPDF from "../../utils/exportPDF";
import accountQuery, { deleteAccount } from "../../utils/queries/accountQuery";
import NewAccount from "./NewAccount";
import { ViewSingleSite } from "../Sites";
import { ViewSinglePosition } from "../JobPositions";
import { defineRole } from "../../utils/handleAccessRoles";
import { getStorage } from "../../utils/storage";
import { Permissions } from "../AccessRole";
import { menus } from "../../constants/accessRolesList";
import { ROLE_ACCOUNT } from "../../constants/ROLES";
import icons from "../../constants/icons";

// eslint-disable-next-line no-unused-vars
let copyData = [];
// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-unused-vars
class Accounts extends React.Component {
// eslint-disable-next-line no-unused-vars
  csvDownload = React.createRef();

// eslint-disable-next-line no-unused-vars
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    totalPageCount: 10,
    delete_password: "",
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({ error, [field]: e?.target?.value });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage, isActive } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await accountQuery(defaultLanguage, {
        page,
        limit,
        active: isActive,
        ...search,
      });

      this.setState({
        data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleLimitChange = (newLimit) => {
    this.setState({ limit: newLimit, page: 1 }, () => {
      this.getData(true);
    });
  };

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
      },
      {
        title: language[this.props.defaultLanguage].username,
        key: "username",
      },
      {
        title: language[this.props.defaultLanguage].email_address,
        key: "email",
        className: "d-none d-lg-table-cell",
        styles: {
          textTransform: "lowercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].department,
        key: "department.name",
        className: "d-none d-md-table-cell",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].job_position,
        key: "position.name",
        className: "d-none d-md-table-cell",
      },
      // {
      //   title: language[this.props.defaultLanguage].center,
      //   key: "center.name",
      // },
      // {
      //   title: language[this.props.defaultLanguage].center_site,
      //   key: "centerSite.name",
      // },
      // {
      //   title: language[this.props.defaultLanguage].access_role,
      //   key: "accessRole[0].name",
      //   type: "link",
      //   onPress: (item) =>
      //     this.handleShowModal(
      //       "showRoleModal",
      //       language[this.props.defaultLanguage].access_role,
      //       item.accessRole
      //     ),
      //   styles: {
      //     textTransform: "uppercase",
      //   },
      // },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        className: "d-none d-lg-table-cell",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].last_login,
        key: "lastLogin",
        className: "d-none d-lg-table-cell",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteAccount(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { page, limit } = this.state;
      const { defaultLanguage, isActive } = this.props;

      const { data } = await accountQuery(defaultLanguage, {
        page,
        limit,
        active: isActive,
      });

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
    });

    const { page, limit } = this.state;
    const { defaultLanguage, isActive } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await accountQuery(defaultLanguage, {
      page,
      limit,
      active: isActive,
    });

    this.setState({
      isLoading: false,
    });

    exportPDF("Accounts", headers, data);
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    this.setState({ searching: true, page: 1 });

    const q = search?.trim() || undefined;

    await this.getData(true, { q });

    this.setState({ searching: false });
  };

  render() {
    const {
      add_account,
      edit_account,
      delete_account,
      account,
      export_,
      edit,
      delete_,
      view,
// eslint-disable-next-line no-unused-vars
      resend_code,
    } = language[this.props.defaultLanguage];

// eslint-disable-next-line no-unused-vars
    let selectedMenus = [];
    for (let menu of menus(this.props.defaultLanguage)) {
      if (this.state?.selectedData?.permissions?.menus?.includes(menu.value)) {
        selectedMenus.push(menu);
      }
    }

    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange}
          headers={this.returnTableHeaders()}
          showAdd
          addButtonText={add_account}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            account
          )}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          filters={[
            {
              type: "export",
              title: export_,
              button_type: "dropdown",
              icon: "bx bxs-download",
              options: [
                {
                  name: "PDF",
                  onPress: this.downloadPDF.bind(this),
                },
                {
                  name: "CSV",
                  onPress: this.downloadExcel.bind(this),
                },
              ],
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_ACCOUNT,
                operation: "read",
              }),
              name: view,
              icon: icons.eye_on,
              onPress: (item) =>
                this.handleShowModal("showModal", account, item),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_ACCOUNT,
                operation: "update",
              }),
              icon: icons.edit,
              name: edit,
              onPress: (item) =>
                this.handleShowModal("showModal", edit_account, item),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_ACCOUNT,
                operation: "delete",
              }),
              icon: icons.delete,
              name: delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                delete_account
              ),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <NewAccount
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selectedData}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDepartmentModal")}
          show={this.state.showDepartmentModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <ViewSingleSite
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDepartmentModal"
            )}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showPositionModal")}
          show={this.state.showPositionModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <ViewSinglePosition
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showPositionModal"
            )}
            getData={this.getData.bind(this)}
            data={this.state.selectedData?.department || []}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showRoleModal")}
          show={this.state.showRoleModal}
          title={this.state?.selectedData?.name}
          showHeaderBottomBorder={false}
        >
          <div className="card-body">
            {selectedMenus?.map((menu, m) => {
              return (
                <div className="col-md-12" key={m}>
                  <Permissions
                    title={menu.value}
                    key={m}
                    operationMenus={
                      this.state?.selectedData?.permissions?.operationMenus
                    }
                    operations={menu.operations}
                    menuItem={menu.value}
                  />
                </div>
              );
            })}
          </div>
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"Accounts" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Accounts);
